import React, { Component } from "react";
import { branch } from "baobab-react/higher-order";
import _ from "lodash";

import * as playerActions from "../../actions/playerActions";
import * as Utils from "../../utils/utils";

const thumbnailWidth = "300px";
const thumbnailHeight = "300px";

class SketchPad extends Component {

	constructor(props) {
		super(props);
		this.state = {
		};
	}

	render() {
		let theme = this.props.activityTheme ? this.props.activityTheme : global.activityTheme;

		let addtlStyleProps = {};
		if (this.props.item.sketchPadBackgroundColor && !_.isEmpty(this.props.item.sketchPadBackgroundColor)) {
			addtlStyleProps.backgroundColor = this.props.item.sketchPadBackgroundColor;
		} 

		const sketchPadStyle = _.assign({}, { flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", margin: 0, padding: 0, backgroundColor: this.props.item.sketchPadBackgroundColor, borderStyle: "dashed", borderColor: "gray", borderWidth: 3, backgroundSize: "contain", maxWidth: thumbnailWidth, maxHeight: thumbnailHeight, width: "100%", height: "100%"}, theme.item.sketchPad, addtlStyleProps);

		let sketchPad;
		// console.log("Sketch Pad Image", this.props.item.sketchPadImage);
		if (this.props.item.hasOwnProperty("sketchPadImage") && this.props.item.sketchPadImage !== null) {			
			sketchPad =
				<div style={sketchPadStyle}>
				<img alt="" src={this.props.item.sketchPadImage} style={{ maxWidth: thumbnailWidth, maxHeight: thumbnailHeight}}/>
				</div>;				
		} else {
			sketchPad =
				<div style={sketchPadStyle}>
					<div style={_.assign({}, { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", fontSize: 20, color: "gray", padding: 5, width: "100%", height: "500px"}, Utils.getFontStyles(sketchPadStyle))}>{this.props.item.sketchPadPlaceholderText ? this.props.item.sketchPadPlaceholderText : "Click to Draw"}</div>
				</div>
		
		}

		return (
			<div style={{
				flex: 1, width: "100%", flexDirection: "column", alignItems: "center", justifyContent: "center"
			}}>				
				<div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
					<div style={{ cursor: "pointer", maxWidth: "300px", width: "100%" }} onClick={(e) => {
						this.props.dispatch(
							playerActions.showSketchPad,
							this.props.listIndex,
							this.props.sectionIndex,
							this.props.itemIndex,
							this.props.item,
							true
						);
					}}>
						{sketchPad}
					</div>
				</div>
			</div>
		);
	}
}

export default branch({
}, SketchPad);
